// extracted by mini-css-extract-plugin
export default {"balance":"Amount_balance__6mj3a","balanceText":"Amount_balanceText__mQy4W"};